import { Button } from '../ui/button';
import { CheckCircle2 } from 'lucide-react';

const BlockedDatesList = ({ blockedDates, onUnblockDate }) => {
    if (blockedDates.length === 0) {
        return <p className="text-center text-muted-foreground py-8">No blocked dates</p>;
    }

    return (
        <div className="space-y-3 max-h-[500px] overflow-y-auto">
            {blockedDates.map((block) => {
                const dateDisplay = block.start_date === block.end_date 
                    ? block.start_date 
                    : block.start_date + ' - ' + block.end_date;

                return (
                    <div key={block.id} className="p-4 bg-gray-50 border border-gray-200 rounded-lg">
                        <div className="flex justify-between items-start">
                            <div>
                                <p className="font-semibold text-foreground">{dateDisplay}</p>
                                {block.note && (
                                    <p className="text-sm text-muted-foreground mt-1">{block.note}</p>
                                )}
                            </div>
                            <Button
                                size="sm"
                                variant="outline"
                                className="text-green-600 hover:bg-green-50"
                                onClick={() => onUnblockDate(block.id)}
                                data-testid={'unblock-btn-' + block.id}
                            >
                                <CheckCircle2 className="w-4 h-4 mr-1" />
                                Unblock
                            </Button>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default BlockedDatesList;
